var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bsw-icon",style:({ width: `${_vm.size}px`, height: `${_vm.size}px` })},[_c('div',{staticClass:"bsw-icon__layer bsw-obs",class:{ 'is-on': !_vm.showPrism }}),_c('div',{staticClass:"bsw-icon__layer bsw-prism",class:{ 'is-on': _vm.showPrism }})])
}
var staticRenderFns = []

export { render, staticRenderFns }